import { createReducer, on } from '@ngrx/store';
import { DataTableSort } from 'studio-components';
import {
  AdminApiKeyPageLoadedAction,
  AdminApiKeyPageRequestedAction,
  AdminApiKeysLoadedAction,
  AdminApiKeySortChangedAction,
} from './admin-api-key/admin-api-key.actions';
import {
  ApiKeyPageLoadedAction,
  ApiKeyPageRequestedAction,
  ApiKeysErroredAction,
  ApiKeysLoadedAction,
  ApiKeySortChangedAction,
} from './api-key.actions';
import { ApiKeyApiError } from './api-key.errors';
import { ApiKey } from './api-key.model';

export interface ApiKeyState {
  ids: number[];
  entities: Record<number, ApiKey>;
  loaded: boolean;
  apiError: ApiKeyApiError;
  sort: DataTableSort | null;
}

const initialState: ApiKeyState = {
  ids: [],
  entities: {},
  loaded: false,
  apiError: null,
  sort: null,
};

export const apiKeyReducer = createReducer(
  initialState,
  on(ApiKeySortChangedAction, AdminApiKeySortChangedAction, (state, action) => ({
    ...state,
    ...(action.sort ? { sort: action.sort } : null),
    loaded: false,
    apiError: null,
  })),
  on(
    ApiKeyPageLoadedAction,
    ApiKeyPageRequestedAction,
    AdminApiKeyPageLoadedAction,
    AdminApiKeyPageRequestedAction,
    (state) => ({
      ...state,
      ids: [],
      entities: {},
      loaded: false,
      apiError: null,
    }),
  ),
  on(ApiKeysLoadedAction, AdminApiKeysLoadedAction, (state, { apiKeys }) => ({
    ...state,
    ids: apiKeys.map((apiKey) => apiKey.id),
    entities: apiKeys.reduce((object, apiKey) => {
      object[apiKey.id] = apiKey;
      return object;
    }, {}),
    apiError: null,
    loaded: true,
  })),
  on(ApiKeysErroredAction, (state, { error }) => ({
    ...state,
    ids: [],
    entities: {},
    loaded: false,
    apiError: error,
  })),
);
